<div class="ui-g form-container panel-div">
  <form [formGroup]="bookingChauffeurForm" class="ui-g-12">
    <div class="ui-g">
      <div class="form-field ui-g-12 ui-md-12 ui-lg-12">
        <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["general"]'>
          <div *ngFor="let ErrorMessage of packageApiError['general']">
            {{ErrorMessage.message}}
          </div>
        </div>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g">
        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="username" translate>label_pickup_location </label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <input type="text" id="pickme" [placeholder]="label_pickup" name="pickme" pInputText formControlName="pickupLocation"
              appSearchLocation (setAddress)="setPickup($event)" (keyup)="true" (focus)='!packageApiError[0]["pickupLocationName"]=false' />
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["pickupLocationName"]'>
            <div *ngFor="let ErrorMessage of packageApiError['pickupLocationName']">
              {{ErrorMessage.message}}
            </div>
          </div>
          <div class="form-errors" *ngIf="bookingChauffeurForm.controls.pickupLocation.errors  && (bookingChauffeurForm.controls.pickupLocation.dirty || bookingChauffeurForm.controls.pickupLocation.touched)">
            <div [hidden]="!bookingChauffeurForm.controls.pickupLocation.errors.required" translate>
              pickup_location
            </div>
          </div>
        </div>
        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="username" translate>label_drop_location</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <input type="text" d="dropme" [placeholder]="label_drop" name="dropkme" pInputText formControlName="dropLocation"
              appSearchLocation (setAddress)="setDropUp($event)" />
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["dropLocationName"]'>
            <div *ngFor="let ErrorMessage of packageApiError['dropLocationName']">
              {{ErrorMessage.message}}
            </div>
          </div>
          <div class="form-errors" *ngIf="bookingChauffeurForm.controls.dropLocation.errors  && (bookingChauffeurForm.controls.dropLocation.dirty || bookingChauffeurForm.controls.dropLocation.touched)">
            <div [hidden]="!bookingChauffeurForm.controls.dropLocation.errors.required" translate>
              drop_location
            </div>
          </div>
        </div>
        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="username" translate>label_pickup_date_time</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <p-datepicker formControlName="pickupDate" [defaultDate]="minDate" [minDate]="minDate" [readonlyInput]="true"
              dateFormat="{{dateFormat}}" [showTime]="true" [showIcon]="true"> </p-datepicker>
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["pickupDateTime"]'>
            <div *ngFor="let ErrorMessage of packageApiError['pickupDateTime']">
              {{ErrorMessage.message}}
            </div>
          </div>
          <div class="form-errors" *ngIf="bookingChauffeurForm.controls.pickupDate.errors  && (bookingChauffeurForm.controls.pickupDate.dirty || bookingChauffeurForm.controls.pickupDate.touched)">
            <div [hidden]="!bookingChauffeurForm.controls.pickupDate.errors.required" translate>
              booking_date
            </div>
          </div>
        </div>
      </div>

      <div class="ui-g">

        <div class="form-field ui-g-12 ui-md-4 ui-lg-4  ui-g-nopad">

          <div class="form-label  ui-g-12 lable-mobile-number">
            <label for="username" translate>label_mobile_no</label>
            <label class="asterisk">*</label>
          </div>

          <div class="ui-g-3  ui-inputgroup mobile-number">
            <span class="ui-inputgroup-addon">
              <i class="fa fa-plus"></i>
            </span>
            <input class="input-mobile-code" type="text" pInputText formControlName="phoneCode" placeholder="Code" />
          </div>

          <div class="form-control ui-g-9 mobile-number">
            <p-autoComplete class="assign" [suggestions]="passengerSearchTextResult" (completeMethod)="passengerSearch($event)"
              placeholder="Type to search passenger" field="phoneNum" formControlName="mobileNo" (onSelect)="onSelectMobileNumber($event)">
              <ng-template let-ref pTemplate="item">
                <span style="font-size:16px">{{ref.phoneNum}}</span>
              </ng-template>
            </p-autoComplete>
          </div>



          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["numCountryCode"]'>
            <div *ngFor="let ErrorMessage of packageApiError['numCountryCode']">
              {{ErrorMessage.message}}
            </div>
          </div>

          <div class="form-errors" *ngIf="bookingChauffeurForm.controls.phoneCode.errors  && (bookingChauffeurForm.controls.phoneCode.dirty || bookingChauffeurForm.controls.phoneCode.touched)">
            <div [hidden]="!bookingChauffeurForm.controls.phoneCode.errors.required" translate>
              country_code_required
            </div>
            <div [hidden]="!bookingChauffeurForm.controls.phoneCode.errors.minlength" translate>
              country_code_invalid
            </div>
            <div [hidden]="!bookingChauffeurForm.controls.phoneCode.errors.maxlength" translate>
              country_code_invalid
            </div>
            <div [hidden]="!bookingChauffeurForm.controls.phoneCode.errors.pattern" translate>
              country_code_invalid
            </div>
          </div>


          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["phoneNum"]'>
            <div *ngFor="let ErrorMessage of packageApiError['phoneNum']">
              {{ErrorMessage.message}}
            </div>
          </div>

          <div class="form-errors" *ngIf="bookingChauffeurForm.controls.mobileNo.errors  && (bookingChauffeurForm.controls.mobileNo.dirty || bookingChauffeurForm.controls.mobileNo.touched)">
            <div [hidden]="!bookingChauffeurForm.controls.mobileNo.errors.required" translate>
              phone_invalid
            </div>
            <div [hidden]="!bookingChauffeurForm.controls.mobileNo.errors.minlength" translate>
              phone_invalid
            </div>
            <div [hidden]="!bookingChauffeurForm.controls.mobileNo.errors.maxlength" translate>
              max_length
            </div>
            <div [hidden]="!bookingChauffeurForm.controls.mobileNo.errors.pattern" translate>
              number_pattern
            </div>
          </div>

        </div>

        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="username" translate>label_email</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <input type="text" pInputText formControlName="email" />
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["phoneNum"]'>
            <div *ngFor="let ErrorMessage of packageApiError['phoneNum']">
              {{ErrorMessage.message}}
            </div>
          </div>
          <div class="form-errors" *ngIf="bookingChauffeurForm.controls.email.errors  && (bookingChauffeurForm.controls.email.dirty || bookingChauffeurForm.controls.email.touched)">
            <div [hidden]="!bookingChauffeurForm.controls.email.errors.required" translate>
              email_required
            </div>
            <div [hidden]="!bookingChauffeurForm.controls.email.errors.pattern" translate>
              email_pattern
            </div>
          </div>
        </div>

        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="username" translate>label_passenger_name</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <input type="text" pInputText formControlName="passengerName" />
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["passengerName"]'>
            <div *ngFor="let ErrorMessage of packageApiError['passengerName']">
              {{ErrorMessage.message}}
            </div>
          </div>
          <div class="form-errors" *ngIf="bookingChauffeurForm.controls.passengerName.errors  && (bookingChauffeurForm.controls.passengerName.dirty || bookingChauffeurForm.controls.passengerName.touched)">
            <div [hidden]="!bookingChauffeurForm.controls.passengerName.errors.required" translate>
              passenger_name
            </div>
            <div [hidden]="!bookingChauffeurForm.controls.passengerName.errors.minlength" translate>
              min_length
            </div>
            <div [hidden]="!bookingChauffeurForm.controls.passengerName.errors.pattern" translate>
              name_pattern
            </div>
          </div>
        </div>
      </div>
      <div class="ui-g">
        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="username" translate>label_packages</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <p-select [options]="(transmission === true)?automaticPackages:manualPackages" formControlName="package"
              filter="filter">
            </p-select>
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["packageId"]'>
            <div *ngFor="let ErrorMessage of packageApiError['packageId']">
              {{ErrorMessage.message}}
            </div>
          </div>
          <div class="form-errors" *ngIf="bookingChauffeurForm.controls.package.errors  && (bookingChauffeurForm.controls.package.dirty || bookingChauffeurForm.controls.package.touched)">
            <div [hidden]="!bookingChauffeurForm.controls.package.errors.required" translate>
              Package_req
            </div>
          </div>
        </div>
        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="username"> &nbsp;</label>
          </div>
          <div class="form-control" style="padding: 4%">
            <p-radioButton name="groupname" value="true" label="Automatic" formControlName="transmissionType" (click)="onTransmissionChange()"></p-radioButton>
            <p-radioButton name="groupname" value="false" label="Manual" formControlName="transmissionType" (click)="onTransmissionChange()"></p-radioButton>
          </div>
        </div>

        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="roomNum" translate>label_room_num</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <input type="text" pInputText formControlName="roomNum" />
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["roomNum"]'>
            <div *ngFor="let ErrorMessage of packageApiError['roomNum']">
              {{ErrorMessage.message}}
            </div>
          </div>
          <div class="form-errors" *ngIf="bookingChauffeurForm.controls.roomNum.errors && (bookingChauffeurForm.controls.roomNum.dirty || bookingChauffeurForm.controls.roomNum.touched)">
            <div [hidden]="!bookingChauffeurForm.controls.roomNum.errors.required" translate>
              lable_room_no_req
            </div>
            <div [hidden]="!bookingChauffeurForm.controls.roomNum.errors.maxlength" translate>
              room_num_max_length
            </div>
          </div>

        </div>
      </div>

      <div class="ui-g">
        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="username" translate>label_Hotels</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <p-select [options]="hotelList" formControlName="hotelNames">
            </p-select>
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["hotelNames"]'>
            <div *ngFor="let ErrorMessage of packageApiError['hotelNames']">
              {{ErrorMessage.message}}
            </div>
          </div>
          <div class="form-errors" *ngIf="bookingChauffeurForm.controls.hotelNames.errors  && (bookingChauffeurForm.controls.hotelNames.dirty || bookingChauffeurForm.controls.hotelNames.touched)">
            <div [hidden]="!bookingChauffeurForm.controls.hotelNames.errors.required" translate>
              hotel_req
            </div>
          </div>
        </div>

        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="quotationAmount" translate>label_quotation_amount_accepted</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <input type="text" pInputText formControlName="quotationAmount" />
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["quotationAmount"]'>
            <div *ngFor="let ErrorMessage of packageApiError['quotationAmount']">
              {{ErrorMessage.message}}
            </div>
          </div>
          <div class="form-errors" *ngIf="bookingChauffeurForm.controls.quotationAmount.errors  && (bookingChauffeurForm.controls.quotationAmount.dirty || bookingChauffeurForm.controls.quotationAmount.touched)">
            <div [hidden]="!bookingChauffeurForm.controls.quotationAmount.errors.required" translate>
              quotation_amount_req
            </div>
            <div [hidden]="!bookingChauffeurForm.controls.quotationAmount.errors.pattern" translate>
              invalid_amount
            </div>
          </div>
        </div>
        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="username" translate>vehicle_details</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <input type="text" pInputText formControlName="makeModel" />
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["makeModel"]'>
            <div *ngFor="let ErrorMessage of packageApiError['makeModel']">
              {{ErrorMessage.message}}
            </div>
          </div>
          <div class="form-errors" *ngIf="bookingChauffeurForm.controls.makeModel.errors  && (bookingChauffeurForm.controls.makeModel.dirty || bookingChauffeurForm.controls.makeModel.touched)">
            <div [hidden]="!bookingChauffeurForm.controls.makeModel.errors.required" translate>
              vehicle_details_req
            </div>
          </div>
        </div>

      </div>
      <div class="ui-g">
        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="note" translate>label_note</label>
          </div>
          <div class="form-control">
            <input type="text" pInputText formControlName="note" />
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["note"]'>
            <div *ngFor="let ErrorMessage of packageApiError['note']">
              {{ErrorMessage.message}}
            </div>
          </div>
        </div>
        <div [hidden]="!isCorporatePassenger" class="ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="note" translate>label_corporate_name</label>
          </div>
          <div class="disguise-read-only">
            {{selectedPassengerCorporate}}
          </div>
        </div>
        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-control" style="padding-top: 6%">
            <p-checkbox class="vip-chk" name="VPassenger" label="VIP Passenger" binary="true" formControlName="VIPPassenger"></p-checkbox>
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["vip"]'>
            <div *ngFor="let ErrorMessage of packageApiError['vip']">
              {{ErrorMessage.message}}
            </div>
          </div>
        </div>
      </div>

      <div class="form-buttons ui-g-12 ui-g-nopad">
        <button class="negative-button" pButton type="button" icon="fa-close" [label]="labelCancel" (click)="cancel()"></button>
        <button pButton type="button" [label]="labelSave" icon="fa-check" [disabled]="!bookingChauffeurForm.valid"
          (click)="addbooking()"></button>
      </div>
    </div>
    <p-toast key="message"></p-toast>
  </form>
</div>